import React from 'react';
import {ImagePicker} from '@pulsoid-private/widgets-lib';
import {Col, Form, Row} from 'react-bootstrap';
import ColorPicker from '../ColorPicker';

const IMAGE_COLOR_TYPE = {
  STATIC: 'static',
  SYNC: 'sync',
  TRANSPARENT: 'transparent',
};

const DEFAULT_IMAGE_CONFIG = {
  size: 60,
  color: '#000000',
  withAnimation: true,
  colorType: IMAGE_COLOR_TYPE.STATIC,
};

export const IconConfiguration = ({configuration, updateConfiguration}) => {
  return (
    <>
      <h4>Icon Configuration</h4>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Widget Icon
        </Form.Label>
        <Col sm="3">
          <ImagePicker
            preset="all"
            selectedItem={configuration.image?.type || null}
            onSelect={(type) =>
              updateConfiguration({
                image: type
                  ? {...DEFAULT_IMAGE_CONFIG, ...configuration.image, type}
                  : null,
              })
            }
          />
        </Col>
      </Form.Group>

      {configuration.image && configuration.image?.type !== null ? (
        <>
          <Form.Group as={Row}>
            <Form.Label column sm="2">
              {/* Widget Icon settings */}
            </Form.Label>

            <Form.Group as={Col} sm="3">
              <Form.Label htmlFor="image.size">Icon Size</Form.Label>
              <Form.Control
                style={{height: 38}}
                id="image.size"
                type="range"
                value={
                  ('size' in configuration.image
                    ? configuration.image.size
                    : DEFAULT_IMAGE_CONFIG.size) / 1.5
                }
                onChange={(e) =>
                  updateConfiguration({
                    image: {
                      ...configuration.image,
                      size: Number(e.target.value) * 1.5,
                    },
                  })
                }
              />
            </Form.Group>
            <Form.Group as={Col} sm="3">
              <Form.Label htmlFor="image.withAnimation">
                Icon Animation
              </Form.Label>
              <Form.Switch
                style={{marginTop: 7}}
                id="image.withAnimation"
                defaultChecked={
                  'withAnimation' in configuration.image
                    ? configuration.image.withAnimation
                    : DEFAULT_IMAGE_CONFIG.withAnimation
                }
                onChange={(e) =>
                  updateConfiguration({
                    image: {
                      ...configuration.image,
                      withAnimation: e.currentTarget.checked,
                    },
                  })
                }
              />
            </Form.Group>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Icon Design
            </Form.Label>

            <Form.Group as={Col} sm="3">
              <Form.Label>Color Type</Form.Label>
              <Form.Control
                as="select"
                value={
                  configuration.image?.colorType || IMAGE_COLOR_TYPE.STATIC
                }
                onChange={(e) =>
                  updateConfiguration({
                    image: {
                      ...configuration.image,
                      colorType: e.target.value,
                    },
                  })
                }
              >
                <option
                  key={IMAGE_COLOR_TYPE.STATIC}
                  value={IMAGE_COLOR_TYPE.STATIC}
                >
                  Static
                </option>
                <option
                  key={IMAGE_COLOR_TYPE.SYNC}
                  value={IMAGE_COLOR_TYPE.SYNC}
                >
                  Sync with BPM
                </option>
                <option
                  key={IMAGE_COLOR_TYPE.TRANSPARENT}
                  value={IMAGE_COLOR_TYPE.TRANSPARENT}
                >
                  Transparent
                </option>
              </Form.Control>
            </Form.Group>

            {configuration.image?.colorType === IMAGE_COLOR_TYPE.STATIC ? (
              <Form.Group as={Col} sm="3">
                <Form.Label>Icon Color</Form.Label>
                <ColorPicker
                  color={
                    configuration.image?.color || DEFAULT_IMAGE_CONFIG.color
                  }
                  onChangeComplete={(color) =>
                    updateConfiguration({
                      image: {...configuration.image, color},
                    })
                  }
                />
              </Form.Group>
            ) : null}
          </Form.Group>
        </>
      ) : null}
    </>
  );
};
